(function(){
    class LocationPageHeader{
    
        constructor( element) {
            this.el = element;
            this.searchLink = element.querySelector('.header-location-link');
            this.closeLink = element.querySelector('.header-search-open a');
    
            this.searchLink.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.el.classList.add('search');
                let closeTextBox = element.querySelector('.mapboxgl-ctrl-geocoder--input');
                closeTextBox.focus();
            });
    
            this.closeLink.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.el.classList.remove('search');
            });
        }
    }
    
    new LocationPageHeader(document.getElementById('header'));

})()

